/* eslint-disable no-alert */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import {
  Header,
  Button,
  Icon,
  Divider,
  Card,
  List,
  Label,
} from 'semantic-ui-react'

import Loading from '../../components/common/loading'
import Form from './Form'

import RestaurantActions from '../../reducers/restaurantReducer'
import CartBasedPromotionAction from '../../reducers/cartBasedPromotionReducer'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  popupContainer: {
    width: '300px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  }
}

const Row = ({ field, value, labelColor, tag }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>
          {field}
        </div>
        <div style={{ display: 'flex' }}>
          <Label size="small" color={labelColor} tag={tag}>
            {value}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

const formData = {
  id: '',
  title: {
    kh: '',
    en: ''
  },
  description: {
    kh: '',
    en: ''
  },
  code: '',
  active: false,
  auto_show:  false,
  target_price: 0,
  trigger_price: 0,
  is_global: false,
  restaurant: '',
  expired_at: '',
  started_at: '',
  discount: 0,
  redemption_failed_alert: false,
}

class CartBasedList extends Component {

  state = {
    formVisible: false,
    action: '',
    cartBasedData: null
  }

  componentDidMount() {
    const { fetchRestaurants, restaurantLoaded, fetchCartBasedPromotions, cartBasedPromotionLoaded } = this.props

    if (!restaurantLoaded) {
      fetchRestaurants()
    }

    if (!cartBasedPromotionLoaded) {
      fetchCartBasedPromotions()
    }
  }

  onSaveCartBased = () => {
    const { cartBasedData } = this.state
    const { saveCartBased } = this.props
    const { is_global: isGlobal, restaurant } = cartBasedData

    if (!isGlobal && !restaurant) {
      alert("Restaurant cannot blank!")
      return false
    }

    saveCartBased(cartBasedData, () => this.setState({ formVisible: false, action: '' }))
  }

  onRemove = cartBasedPromotion => {
    const { deleteCartBased } = this.props

    const confirm = window.confirm(`Are you sure to remove this promotion?`)

    if (confirm) {
      deleteCartBased(cartBasedPromotion.id)
    }
  }

  renderPromotion = (cartBasedPromotion, key) => {
    const { restaurants } = this.props
    const restaurant = restaurants[cartBasedPromotion.restaurant]

    const { title, trigger_price: triggerPrice, target_price: targetPrice, started_at: startedAt, expired_at: expiredAt, code, is_global: isGlobal, active } = cartBasedPromotion
    const restaurantName = _.get(restaurant, 'name', 'N/A')

    return (
      <Card key={key}>
        <Card.Content>
          <Card.Header>{title.en}</Card.Header>
          <Card.Description>
            <List divided verticalAlign='middle' style={{ marginTop: 10 }}>
              <Row field='Restaurant' value={isGlobal ? 'All Restaurants' : restaurantName} />
              <Row field='Code' value={code} />
              <Row field='Trigger Price' value={`${triggerPrice} $`} />
              <Row field='Target Price' value={`${targetPrice} $`} />
              <Row field='Started Date' value={moment(parseInt(startedAt, 10)).format('YYYY-MM-DD')} />
              <Row field='Expired Date' value={moment(parseInt(expiredAt, 10)).format('YYYY-MM-DD')} />
              <Row field='Status' value={ active ? 'Active' : 'Inactive' } />
            </List>
          </Card.Description>
        </Card.Content>
        <Card.Content extra textAlign='right' >
          <Button
            color='black'
            size="tiny"
            onClick={() => this.setState({
              cartBasedData: cartBasedPromotion,
              formVisible: true,
              action: 'edit'
            })}>
            Edit
          </Button>
          <Button
            color='red'
            size="tiny"
            onClick={() => this.onRemove(cartBasedPromotion)}
            >
            Delete
          </Button>
        </Card.Content>
      </Card>
    )
  }

  renderNoCartBasedPromotions = () => {
    return <Header textAlign='center' size="small" style={{ padding: 16 }}>No data available</Header>
  }

  renderCartBasedPromotions = () => {
    const { cartBasedPromotions } = this.props

    return _.map(cartBasedPromotions, (cartBasedPromotion, key) => this.renderPromotion(cartBasedPromotion, key))
  }

  onInputChange = (field, value, locale = "") => {
    let { cartBasedData } = this.state

    if (locale) {
      cartBasedData = {
        ...cartBasedData,
        [field]: {
          ...cartBasedData[field],
          [locale]: value
        }
      }
    } else {
      cartBasedData = {
        ...cartBasedData,
        [field]: value
      }
    }

    this.setState({ cartBasedData })
  }

  onChangeRestaurant = restaurant => {
    let { cartBasedData } = this.state

    cartBasedData = {
      ...cartBasedData,
      restaurant,
    }

    this.setState({ cartBasedData })
  }

  render() {
    const { restaurants, cartBasedPromotions, restaurantLoading, cartBasedPromotionLoading, cartBasedPromotionSaving } = this.props
    const { formVisible, cartBasedData, action } = this.state

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'auto'
        }}
      >
        <Loading active={restaurantLoading || cartBasedPromotionLoading } />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0px 14px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Header style={{ marginBottom: 0 }}>Cart Based Promotions</Header>
          </div>
          <div style={{ display: 'flex' }}>
            <Button icon color="black" onClick={() => this.setState({
              cartBasedData: formData,
              formVisible: true,
              action: 'create'
            })}>
              <Icon name="add" /> Add New
            </Button>
          </div>
        </div>
        <div>
          <Divider style={{ margin: 14 }} />
        </div>

        <Card.Group style={{ margin: 0 }}>
          {
            ( _.size(restaurants) > 0 && _.size(cartBasedPromotions) > 0) ?
              this.renderCartBasedPromotions()
              : this.renderNoCartBasedPromotions()
          }
        </Card.Group>
        {
          formVisible &&
            <Form
              action={action}
              cartBasedData={cartBasedData}
              visible={formVisible}
              restaurants={restaurants}
              onInputChange={this.onInputChange}
              loading={cartBasedPromotionSaving}
              onSaveCartBased={this.onSaveCartBased}
              onClose={() => this.setState({ formVisible: false, action: '' })}
            />
        }
      </div>
    )
  }
}


const mapState = ({restaurants, cartBasedPromotions}) => ({
  restaurants: restaurants.data,
  restaurantLoading: restaurants.loading,
  restaurantLoaded: restaurants.loaded,
  cartBasedPromotions: cartBasedPromotions.data,
  cartBasedPromotionLoading: cartBasedPromotions.loading,
  cartBasedPromotionLoaded: cartBasedPromotions.loaded,
  cartBasedPromotionSaving: cartBasedPromotions.saving,
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
  fetchCartBasedPromotions: CartBasedPromotionAction.getCartBasedPromotions,
  saveCartBased: CartBasedPromotionAction.saveCartBasedPromotion,
  deleteCartBased: CartBasedPromotionAction.deleteCartBasedPromotion,
}


export default connect(mapState, mapDispatch)(CartBasedList)



// WEBPACK FOOTER //
// ./src/components/cartBased/index.js